<template>
	<div class="implementers-list">
		<app-table
			class="configuration-table is-not-selectable"
			name="implementers"
			:columns="columns"
			:rows="rowsImplementers"
			:current-page="currentPage"
			:last-page="lastPage"
			@on-search-event="onSearch"
			@on-page="changePage"
		>
			<template slot="rows" slot-scope="props">
				<td class="is-not-selectable"
				v-show="showRow(columns, 1)">
					{{ props.row.fullName }}
				</td>
				<td v-show="showRow(columns, 2)">
					{{ props.row.email }}
				</td>
				<td v-show="showRow(columns, 3)">
					{{ props.row.phone }}
				</td>
				<td v-show="showRow(columns, 4)">
					{{ props.row.distributor.data.name }}
				</td>
				<td v-show="showRow(columns, 5)">
					{{ props.row.country.data.name }}
				</td>
				<td class="configuration-actions-cell">
					<app-tooltip-button
						color="primary"
						icon="location_city"
						text="Empresa"
						@click-icon="goToCompany(props.row)"
					/>
					<app-tooltip-button
						color="green"
						icon="edit"
						text="Editar"
						@click-icon="goToDeatil(props.row.id)"
					/>
					<app-tooltip-button
						color="red"
						icon="delete"
						text="Eliminar App"
						@click-icon="openDialog(props.row)"
					/>
				</td>
			</template>
		</app-table>
		<v-dialog v-model="dialog" persistent max-width="500">
			<v-card>
				<v-card-title class="subheading">{{ dialogMessage }}</v-card-title>
				<v-card-actions class="justify-center">
					<v-btn
						class="btn-action"
						color="green"
						dark
						@click.native="deleteImplementers"
					>
						SI
					</v-btn>
					<v-btn
						class="btn-action"
						color="error"
						dark
						@click.native="closeDialog"
					>
						NO
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import appTooltipButton from '@/components/shared/app-tooltip-button';

function created() {
	this.loadData();
}

function onSearch(search) {
	this.params.search = search ? search.trim() : null;
	this.loadData();
}

function data() {
	return {
		columns: [
			{ id: 1, name: 'Nombre', value: 'name', checked: true, visible: true },
			{ id: 2, name: 'Correo', value: 'email', checked: true, visible: true },
			{ id: 3, name: 'Teléfono', value: 'phone', checked: true, visible: true },
			{ id: 4, name: '#Compañia', value: 'numberCompany', checked: true, visible: true },
			{ id: 5, name: 'País', value: 'country', checked: true, visible: true },
			{ id: 6, name: 'Acciones', value: 'actions', checked: true, visible: true },
		],
		checkAll: false,
		currentPage: 1,
		dialog: false,
		dialogMessage: '',
		idDelete: null,
		lastPage: 0,
		params: {
			page: 1,
		},
		rowsImplementers: [],
	};
}

function changePage(page) {
	this.currentPage = page;
	this.loadData();
}

async function loadData() {
	this.params.page = this.currentPage;
	try {
		const response = await this.$http.get('implementers', { params: this.params });
		this.rowsImplementers = response.data.data;
		this.lastPage = Number(response.headers['x-last-page']);
	} catch (error) {
		this.showError();
	}
}

function goToCompany({ id }) {
	this.goTo('page-implementers-company', { params: { id } });
}

function goToDeatil(id) {
	this.goTo('page-implementers-create', { params: { id } });
}

function newRoute(newValue, afterValue) {
	if (newValue.name === 'page-config-implementers' && afterValue.name === 'page-implementers-create') {
		this.loadData();
	}
}

function openDialog(item) {
	this.dialogMessage = `¿Desea eliminar de la lista a '${item.name}'?`;
	this.idDelete = item.id;
	this.dialog = true;
}

function closeDialog() {
	this.dialog = false;
	this.dialogMessage = '';
	this.idDelete = null;
}

async function deleteImplementers() {
	try {
		await this.$http.delete(`implementers/${this.idDelete}`);
		this.showNotification('Se eliminó correctamente');
		this.closeDialog();
		this.loadData();
	} catch (error) {
		if (error.status === 405) {
			if (error.data.message === 'USER_HAS_ASSOCIATED_DATA') {
				this.showError('Tiene datos asociados');
			}
		} else {
			this.showError();
		}
	}
}

export default {
	name: 'implementers-list',
	created,
	data,
	components: {
		appTooltipButton,
	},
	methods: {
		changePage,
		goToCompany,
		loadData,
		goToDeatil,
		closeDialog,
		deleteImplementers,
		onSearch,
		openDialog,
	},
	watch: {
		$route: newRoute,
	},
};
</script>

<style lang="scss" scoped>
.implementers-list { width: 100%; }
.configuration-actions-cell { white-space: nowrap; }
</style>



// WEBPACK FOOTER //
// src/components/configuration/implementers-list.vue